import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import orderConfig from 'emun.order/order.config'

export default class EmailOrderPromptController {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        const params = Object.assign({}, options, $ctrl.options);
        $ctrl.model = params.model;
        $ctrl.bus = new ServiceBus();
		$ctrl.title = params.title || "Email Order...";
		if (!$ctrl.emailIsValid($ctrl.model.from)) $ctrl.model.from = "";
		if (!$ctrl.model.to) {
			$ctrl.bus.send('QueryCarts.json?Fields=RetailerId&Id=' + $ctrl.model.orderNumber).then(function (orders) {
				if (orders.data.results.length) {
					$ctrl.bus.send('QueryRetailerContacts.json?IsPrimary=1&RetailerId=' + orders.data.results[0].retailerId).then(function (retailers) {
						if (retailers.data.results.length) {
							$ctrl.model.to = retailers.data.results[0].email;
						}
					});
				}
			});
		}
		if (!$ctrl.model.cc && orderConfig.emailOrderCCRep) {
			$ctrl.bus.send('QueryCarts.json?Id=' + $ctrl.model.orderNumber).then(function(res) {
				if (res.data.results.length) {
					$ctrl.model.cc = res.data.results[0].repBy.email || "";
				}
			})
		}
    }

	emailIsValid(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}
    submit() {
        const $ctrl = this;
		$ctrl.emailSent = false;
		if (Array.isArray($ctrl.model.orderNumber)) {
			$ctrl.model.orderNumbers = $ctrl.model.orderNumber;
			$ctrl.bus
				.send("EmailOrders.json", $ctrl.model)
				.then(res => $ctrl.emailSent = true);
			// $ctrl.$close();
		} else {
			$ctrl.bus
				.send("EmailOrder.json", $ctrl.model)
				.then(res => $ctrl.emailSent = true);
//				.then(res => $ctrl.$close(res.data));
		}
    }
}